<mat-dialog-content class="custom-modal-container">
  <h5 class="text-center text-title-modal" mat-dialog-title>
    Information deal
  </h5>
  <div class="row">
    <div class="col-lg-12 text-center">
      <div class="row">
        <div class="col-md-12">
          <span class="text-white">Comment:</span>
          <h5 class="text-black">{{ data.comment }}</h5>
        </div>
      </div>
    </div>
  </div>
  <mat-dialog-actions class="text-black-50 justify-content-center">
    <button
      (click)="close()"
      class="btn btn-block btn-sm btn-info text-white"
      mat-button
    >
      Close
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
